import { svg } from 'lit';

export default svg`
  <svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <path d="M10.3571429 9.41666665 L8.10714286 9.41666665 L8.10714286 12.25 L10.3571429 12.25 L10.3571429 20.75 L14.1071429 20.75 L14.1071429 12.25 L16.8386429 12.25 L17.1071429 9.41666665 L14.1071429 9.41666665 L14.1071429 8.23587499 C14.1071429 7.55941666 14.2511429 7.29166666 14.9433929 7.29166666 L17.1071429 7.29166666 L17.1071429 3.75 L14.2511429 3.75 C11.5541429 3.75 10.3571429 4.87129166 10.3571429 7.01895832 L10.3571429 9.41666665 Z"></path>
  </svg>
`;
